import { Box, Checkbox, Dialog, FormControl, FormControlLabel, FormGroup, Grid, IconButton, MenuItem, Select, Skeleton, Stack, Theme, Typography, useTheme } from '@mui/material';
import { Form, Formik, FormikProps } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { ReportSectionContainer, ReportsRightLayout } from '../../InvestorReport/index';
import { getDashboardReports, getInvestorReports } from '../../../redux-store/actions/investorReports';
import {
    downloadMultipleFiles,
    formatDate,
    maskInfo,
    replaceLetterOWithW,
} from '../../../utils/utilityFunctions';
import { TextDatePicker } from '../../onboarding/DatePickerWithTextFeild';
import { MFSubmitButton } from '../../../lib/formik';
import { validationSchemaPortfolioSummary } from '../../../utils/schema';
import { Location } from 'history';
import { useHistory } from 'react-router';
import FormMultiSelect from '../../../lib/formik/FormMultiSelect';
import { getRMDashBoardMetrics } from '../../../redux-store/actions/userManagement';
import { useEffect, useRef, useState } from 'react';
import { ReportsListObj, ReportsListRes, RmDashboardType } from '../../../redux-store/types/api-types';
import { useFormik } from 'formik';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import MFSelectField from '../../../lib/formik/SelectField';
import { RootStateType } from '../../../redux-store/reducers';
import { getMFTransactionWiseReport, getReportsInvestorList } from '../../../redux-store/actions/reports';
import * as Yup from 'yup';
import { DayJsDatePicker } from '../../onboarding/newDatePicker';
import { reportDownload } from '../../Reports/report-utils';
import { DialogCloseIcon, YellowWarning } from '../../../assets/SvgIcons';
import FormikSearchDropdown from '../../../lib/formik/FormikSearchDropdown';
import { USER_ROLES } from '../../../utils/constant';
import { CONTENT_TYPE } from '../../../utils/constant';

interface Values {
    selectedInvestor?: ReportsListObj | null;
    downloadOption?: string;
    date: any;
}

// const downloadOptions = [
//     { key: 'PDF', value: 'pdf' },
//     { key: 'Excel', value: 'excel' },
// ]


export function MFTransactionWiseHoldingReport({
    handleSideSectionDisabled
}: {
    handleSideSectionDisabled: (value: boolean) => void
}): JSX.Element {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState<boolean>(false);
    const { iwappRmId } = useSelector((state: RootStateType) => state.id);
    const [investorListData, setInvestorListData] = useState<ReportsListRes>({} as ReportsListRes);
    const [isDownloading, setIsDownloading] = useState<boolean>(false);
    const [isNoInvestorDialogVisible, setNoInvestorDialogVisible] = useState<boolean>(false)
    const { isNavbarInfoLoading, businessDate } = useSelector((state: RootStateType) => state.navbarInfo);

    const formikRef = useRef<FormikProps<Values>>(null);
    const { role = '' } = useSelector((state: RootStateType) => state.auth);
    const { investorClientId = "" } = useSelector((state: RootStateType) => state.id);

    const fetchInvestorList = async () => {
        try {
            setLoading(true);
            const payload = {
                rmId: `${iwappRmId}`
            }
            const response = await (dispatch(getReportsInvestorList(payload)) as unknown as Promise<ReportsListRes>);
            setInvestorListData(response);
            if (!response?.isSuccess) {
                setNoInvestorDialogVisible(true)
            }
        } catch (e) {
            console.log((e as Error).message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        role === USER_ROLES.RM && fetchInvestorList();
    }, [])

    const todayDate = new Date();
    const formattedBusinessDate = businessDate?.length ? dayjs(businessDate, "DD/MM/YYYY").format("YYYY-MM-DD") : dayjs(todayDate).format("YYYY-MM-DD");

    const initialValues: Values = {
        ...(role === USER_ROLES.RM ? { selectedInvestor: null } : {}),
        downloadOption: '',
        date: formattedBusinessDate
    };


    const mfTransactionValidations = Yup.object().shape({
        ...(role === USER_ROLES.RM ? {
            selectedInvestor: Yup.object()
                .nullable()
                .test(
                    "investor-required",
                    "Please select an investor",
                    function (value) {
                        return !!value;
                    }
                )
        } : {}),
        // downloadOption: Yup.string().required('Please select download option'),
        date: Yup.
            date()
            .required('Date is required')
            .typeError('Date is required')
            .min(dayjs("1950-01-01").format("YYYY-MM-DD"), "Date should not be less than 01/01/1950")
            .max(formattedBusinessDate, "Date should not be greater than system's date")

    })

    const handleSubmit = async ({
        selectedInvestor,
        downloadOption,
        date
    }: Values) => {
        try {
            setIsDownloading(true)
            handleSideSectionDisabled(true)
            const payload = {
                investorName: role === USER_ROLES.RM ? selectedInvestor?.customerName ?? '' : '',
                end: dayjs(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
                // isPDF: (downloadOption ?? "").toLowerCase() === 'pdf' ? true : false,
                isPDF:true,
                //adding clientCode
                clientCode: role === USER_ROLES.RM ? selectedInvestor?.clientCode ?? '' : investorClientId ?? ''
            }

            const response = await (dispatch(getMFTransactionWiseReport(payload)) as unknown as Promise<any>)
            if (response.type) {
                enqueueSnackbar('File downloaded successfully.', {
                    variant: 'success',
                    autoHideDuration: 2000,
                });
                reportDownload(response as unknown as Blob, `MFTransactionWiseReports.${response.type === CONTENT_TYPE.PDF ? 'pdf' : 'xlsx'}`);
            } else {
                enqueueSnackbar('File download failed!.', {
                    variant: 'error',
                    autoHideDuration: 2000,
                });
            }

        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setIsDownloading(false)
            handleSideSectionDisabled(false)
        }
    }

    const handleNoInvestorDialogClose = () => {
        setNoInvestorDialogVisible(false)
    }

    const handleInvestorChange = (selectedObj: Record<string, any>) => {
        if (!formikRef.current) return

        const { values, setValues } = formikRef.current ?? {}

        if (!selectedObj) {
            setValues({
                ...values,
                selectedInvestor: null,
            })

            return
        }

        setValues({
            ...values,
            selectedInvestor: selectedObj as ReportsListObj,
        })
    }


    return (
        <>
            <ReportsRightLayout >
                <Typography
                    variant='h2'
                    sx={{
                        color: 'text.primary',
                        lineHeight: '25px',
                        letterSpacing: '0.01px',
                        mb: '40px',
                    }}>
                    MF Transaction-wise Holding Report
                </Typography>

                <Formik
                    innerRef={formikRef}
                    validationSchema={mfTransactionValidations}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize={true}
                >
                    {({ values, setFieldValue }) => (
                        <Form>
                            <Grid container rowSpacing={4} >
                                <Grid item container columnSpacing={3}>
                                    {role === USER_ROLES.RM && <Grid item xs={12} lg={6}>
                                        {(loading || isNavbarInfoLoading) && <Skeleton
                                            animation={'wave'}
                                            height={90}

                                        />}
                                        {(!loading && !isNavbarInfoLoading) && (
                                            <FormikSearchDropdown
                                                name='selectedInvestor'
                                                label='Select Investor *'
                                                options={(investorListData?.result ?? [])?.map((obj: ReportsListObj) => ({
                                                    ...obj,
                                                    label: `${maskInfo(obj.customerName)} (${obj?.clientCode ?? ""}) ${obj?.accountType ? " - " + obj.accountType : ""}`,
                                                    value: obj.clientCode
                                                }))}
                                                onChange={handleInvestorChange}
                                                disabled={loading || isDownloading || isNavbarInfoLoading}
                                            />
                                        )}
                                    </Grid>}
                                    <Grid item xs={12} lg={6}>
                                        {(loading || isNavbarInfoLoading) && <Skeleton
                                            animation={'wave'}
                                            height={90}

                                        />}
                                        {(!loading && !isNavbarInfoLoading) && <DayJsDatePicker
                                            id=""
                                            name='date'
                                            label="Select Date *"
                                            maxDate={new Date(formattedBusinessDate)}
                                            disabled={loading || isDownloading || isNavbarInfoLoading}
                                            currentDate={formattedBusinessDate}
                                        />}

                                    </Grid>
                                    {/* <Grid item xs={12} lg={6}>
                                        {(loading || isNavbarInfoLoading) && <Skeleton
                                            animation={'wave'}
                                            height={90}

                                        />}
                                        {(!loading && !isNavbarInfoLoading) && <MFSelectField
                                            name={'downloadOption'}
                                            label="Select Download Option"
                                            items={downloadOptions}
                                            value={values.downloadOption}
                                            onChange={(e) => {
                                                setFieldValue('downloadOption', e.target.value);
                                            }}
                                            disabled={isDownloading}
                                        />}
                                    </Grid> */}

                                </Grid>
                                <Grid item container columnSpacing={3} justifyContent={"flex-end"}>
                                    <Grid item xs={12} lg={6}>
                                        {(loading || isNavbarInfoLoading) && <Skeleton
                                            animation={'wave'}
                                            height={90}

                                        />}
                                        {(!loading && !isNavbarInfoLoading) && <MFSubmitButton
                                            label="Download"
                                            loadingEnable={isDownloading}
                                            disabled={loading}
                                        />}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </ReportsRightLayout>
            <Dialog
                onClose={handleNoInvestorDialogClose}
                open={isNoInvestorDialogVisible}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "22px 24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "8px",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                columnGap: "12px",
                                alignItems: "center"
                            }}
                        >
                            <YellowWarning />
                            <Typography
                                variant="h2"
                                sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
                            >
                                No Investor Found!!
                            </Typography>
                        </Box>
                        <IconButton
                            aria-label="close"
                            onClick={handleNoInvestorDialogClose}
                            sx={{
                                padding: "5px"
                            }}
                        >
                            <DialogCloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            </Dialog>
        </>
    );
};


